import { ProductListGroupingType } from '@epicuro-next/data/engagement/engagement-models';
import { SearchSortType } from 'graphql-api/gql-api-interfaces';

export function mapSearchSortTypeByOrdinal(sortType?: SearchSortType | null) {
  return sortType ?? SearchSortType.Inbound;
}

export function mapSearchSortToListGroupingType(
  sortType?: SearchSortType | null,
): ProductListGroupingType {
  if (sortType === SearchSortType.Category) {
    return ProductListGroupingType.Category;
  }

  return ProductListGroupingType.None;
}

export function mapListGroupingTypeToSearchSort(
  groupingType?: ProductListGroupingType,
): SearchSortType | null {
  if (groupingType === ProductListGroupingType.Category) {
    return SearchSortType.Category;
  }

  return null;
}
